import React from "react";

export default function unauthorized() {
  return (
    <div>
      <div className="title">
        <h1>401</h1>
        <p>Unauthorized</p>
      </div>
    </div>
  );
}
